export const getRoomList = async (sendAndWaitWs) => {
  const request = {};
  const response = await sendAndWaitWs("/room/list", JSON.stringify(request));
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const getRoom = async (sendAndWaitWs, roomId) => {
  const request = { roomId };
  const response = await sendAndWaitWs("/room/get", JSON.stringify(request));
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const saveRoom = async (sendAndWaitWs, roomId, roomName) => {
  const request = { roomId, roomName };
  const response = await sendAndWaitWs("/room/save", JSON.stringify(request));
  if (response.error) {
    return false;
  }
  const jsonData = JSON.parse(response.payload);
  return jsonData && jsonData.success;
};

export const deleteRoom = async (sendAndWaitWs, roomId) => {
  const request = { roomId };
  const response = await sendAndWaitWs("/room/delete", JSON.stringify(request));
  if (response.error) {
    return false;
  }
  const jsonData = JSON.parse(response.payload);
  return jsonData && jsonData.success;
};

export const moveDevice = async (sendAndWaitWs, toRoomId, items) => {
  const request = { toRoomId, items };
  const response = await sendAndWaitWs(
    "/room/moveDevice",
    JSON.stringify(request)
  );
  if (response.error) {
    return false;
  }
  const jsonData = JSON.parse(response.payload);
  return jsonData && jsonData.success;
};

export const moveRoom = async (sendAndWaitWs, newIndexes) => {
  const request = { newIndexes };
  const response = await sendAndWaitWs(
    "/room/reorder",
    JSON.stringify(request)
  );
  if (response.error) {
    return false;
  }
  const jsonData = JSON.parse(response.payload);
  return jsonData && jsonData.success;
};
